// Paleta curada de 30 colores para identificar a cada persona (avatares,
// nombres en hilos, menciones). Elegidos a mano para que sean:
//  - distintos entre sí (hue variado, fácil de diferenciar de un vistazo),
//  - legibles sobre fondo blanco,
//  - con contraste suficiente para el texto BLANCO de los avatares.
//
// IMPORTANTE: esta lista debe mantenerse sincronizada con la paleta del
// trigger `handle_new_user` (supabase/sql/profile-color-autoassign.sql), que
// autoasigna a cada usuario nuevo un color libre de su equipo.
export const PROFILE_PALETTE: string[] = [
  '#dc2626', // red-600
  '#ea580c', // orange-600
  '#d97706', // amber-600
  '#ca8a04', // yellow-600
  '#65a30d', // lime-600
  '#16a34a', // green-600
  '#059669', // emerald-600
  '#0d9488', // teal-600
  '#0891b2', // cyan-600
  '#0284c7', // sky-600
  '#2563eb', // blue-600
  '#4f46e5', // indigo-600
  '#7c3aed', // violet-600
  '#9333ea', // purple-600
  '#c026d3', // fuchsia-600
  '#db2777', // pink-600
  '#e11d48', // rose-600
  '#475569', // slate-600
  '#b91c1c', // red-700
  '#c2410c', // orange-700
  '#4d7c0f', // lime-700
  '#15803d', // green-700
  '#0f766e', // teal-700
  '#0369a1', // sky-700
  '#1d4ed8', // blue-700
  '#4338ca', // indigo-700
  '#6d28d9', // violet-700
  '#a21caf', // fuchsia-700
  '#be185d', // pink-700
  '#334155', // slate-700
];
